import { Alert, AlertTitle, Button } from "@mui/material";
import { Navigate } from "react-router-dom";
import {
  FullScreenLoading,
  HeaderAdmin,
  PageContainer,
} from "../../components";
import { useAuth } from "../../hooks";
import SectionContent from "./section-content";
import SectionSidebar from "./section-sidebar";

export function AdminLayout() {
  const { loading, error, user, setLoading } = useAuth();

  const reloadPage = () => {
    setLoading(true);
    window.location.reload();
  };

  if (loading) return <FullScreenLoading />;

  if (error)
    return (
      <PageContainer>
        <Alert severity="error">
          <AlertTitle className="font-bold">An error occurred</AlertTitle>
          <div className="my-2 mb-4">{error}</div>

          <div className="text-secondary w-max ml-auto">
            <Button variant="outlined" color="inherit" onClick={reloadPage}>
              Reload page
            </Button>
          </div>
        </Alert>
      </PageContainer>
    );

  if (!user || !user?.token) return <Navigate to="/login" />;

  if (user.type?.toUpperCase() !== "ADMIN") return <Navigate to="/" />;

  return (
    <div className="bg-background2 w-screen h-screen flex">
      <SectionSidebar />

      <div className="py-8 flex-1">
        <HeaderAdmin />
        <SectionContent />
      </div>
    </div>
  );
}
